import { Link } from 'react-router-dom';
import { Button, Card } from '../components/Ui';

export default function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center bg-slate-100 p-4">
      <Card className="max-w-lg text-center">
        <div className="text-7xl font-black text-slate-200">404</div>
        <h1 className="mt-2 text-2xl font-black text-slate-950">Página no encontrada</h1>
        <p className="mt-2 text-sm text-slate-500">La dirección no existe o no está disponible para tu cuenta.</p>
        <Link to="/"><Button className="mt-5">Volver al inicio</Button></Link>
      </Card>
    </main>
  );
}
